// angular
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// bootstrap
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";

import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

// kendo
import { GridModule } from "@progress/kendo-angular-grid";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns";
import { PopupModule } from '@progress/kendo-angular-popup';

// app modules
import { ConfigurationRoutingModule } from "./configuration-routing.module";

// app components
import { TenantsComponent } from "./tenants/tenants.component";
import { ServicesComponent } from "./services/services.component";
import { EnvironmentsComponent } from "./environments/environments.component";
import { ServiceConfigurationKeysComponent } from "./service-configuration-keys/service-configuration-keys.component";
import { TenantIdentifiersComponent } from "./tenant-identifiers/tenant-identifiers.component";
import { EnvironmentServicesComponent } from "./environment-services/environment-services.component";
import { TenantEnvironmentsComponent } from "./tenant-environments/tenant-environments.component";
import { TenantComponent } from "./tenant/tenant.component";
import { ConfigurationComponent } from "./configuration.component";
import { DialogModule } from "@progress/kendo-angular-dialog";
import { ServiceDetailComponent } from './service-detail/service-detail.component';
import { ServiceConfigurationKeyDetailComponent } from './service-configuration-key-detail/service-configuration-key-detail.component';

@NgModule({
  declarations: [
    TenantsComponent,
    ServicesComponent,
    EnvironmentsComponent,
    ServiceConfigurationKeysComponent,
    TenantIdentifiersComponent,
    EnvironmentServicesComponent,
    TenantEnvironmentsComponent,
    TenantComponent,
    ConfigurationComponent,
    ServiceDetailComponent,
    ServiceConfigurationKeyDetailComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    GridModule,
    DropDownsModule,
    PopupModule,
    DialogModule,
    ConfigurationRoutingModule,
    FontAwesomeModule,
  ],
})
export class ConfigurationModule {}
